// The admin website's delete calls (guard/delete, client/delete, duty/delete, ...). The list is reloaded
// only after the server has replied, and a refusal is shown.
import { formatServerMessage } from './serverErrors'

export const DELETE_UNREACHABLE = 'Could not reach the server. Please try again.'

// The delete endpoints answer code 200 or 201 when the record is gone; anything else (205 "remove ...
// first", 400 "still assigned", 403, 423 suspended, ...) is a refusal that carries a message.
export function deleteSucceeded(res) {
	const code = res && res.data ? Number(res.data.code) : NaN;
	return code === 200 || code === 201;
}

// The text to show when the delete was refused.
export function deleteFailedMessage(res, fallback) {
	return formatServerMessage(res && res.data ? res.data.message : null, fallback);
}
